import { Box, Stack, Typography } from '@mui/material';

import { COLORS } from '@/styles/tokens/colors';
import { EntityKind } from '@/types/schema';

export interface EstateAccordionContentEmptyStateProps {
  title?: string;
  description?: string;
  entityKind?: EntityKind;
}

export function EstateAccordionContentEmptyState({
  entityKind,
}: EstateAccordionContentEmptyStateProps) {
  let description = 'Add holdings to start tracking assets and liabilities';
  if (entityKind === EntityKind.InsurancePersonalAccount) {
    description = 'Add holdings to start tracking insurance policies';
  }
  return (
    <Box
      sx={{
        backgroundColor: COLORS.GRAY[50],
        border: `1px solid ${COLORS.GRAY[200]}`,
        borderRadius: '4px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        p: 2,
        width: '100%',
      }}
    >
      <Stack
        spacing={1}
        alignItems="center"
        justifyContent="center"
        textAlign="center"
        width="100%"
      >
        <Typography variant="title-s">No holdings</Typography>
        <Typography variant="body-s">{description}</Typography>
      </Stack>
    </Box>
  );
}
